module.exports = __webpack_public_path__ + "static/media/leaf-oak.b767aec3.svg";